import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit {
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() value: number = 0;
  @Output() output = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {}

  valueChanged(e: any) {
    this.output.emit(e.target.value);
  }
}
